
<div class="collapse-item">
  <template v-if="handler.mode === 'flat'">
    <field-item
        v-if="handler.allowObjectModelSelection"
        :disabled="handler.isDisabled(objectModelDataSection.objectModel, objectModelContext)"
        @click="select(objectModelDataSection.select(objectModel, path))"
    >
    <row>
      <prefix>
        <icon glyph="object-model"/>
      </prefix>
      <column>
        {{ objectModelDataSection.objectModel.title }}
      </column>
    </row>

    </field-item>

    <button
        data-toggle="collapse"
        :href="`#objectModelPropertiesCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`"
        role="button"
        :aria-expanded="propertiesIsOpen.toString()"
        aria-controls="objectModelPropertiesCollapse"
        :class="{collapsed: !propertiesIsOpen}">
      {{handler.header}}
    </button>
    <div class="collapse" :class="{show: propertiesIsOpen}" :id="`objectModelPropertiesCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`">
      <template v-if="modeIs('select')">
        <field-item
            v-for="prop in handler.objectModelPropertiesSection(lowerQ, objectModel).properties"
            :key="prop.clientIdOrId"
            :disabled="handler.isDisabled(prop, computedChildTreeContext)"
            @click="select(handler.objectModelPropertiesSection(lowerQ, objectModel).select(prop, objectModel, completePathFor(prop)))"
        >
          <row>
            <prefix>
              <icon :glyph="ObjectModelPropertyDefinition.getIcon(prop.elementType)"/>
            </prefix>
            <column>
              {{prop.labelTitleDisplay}}
            </column>
          </row>
        </field-item>
      </template>
      <slot></slot>
    </div>
  </template>
</div>
